import { DonationType } from './donation.model';

export class SetDonationType {
  static readonly type = '[Donation] Set Donation Type';
  constructor(public payload: DonationType) {}
}

export class SetDonationAmount {
  static readonly type = '[Donation] Set Donation Amount';
  constructor(public payload: number) {}
}

export class SetDonationDouble {
  static readonly type = '[Donation] Set Donation Double';
  constructor(public payload: string) {}
}

export class SetDonationEnabledTypes {
  static readonly type = '[Donation] Set Donation EnabledTypes';
  constructor(public payload: {text: 'string', value: DonationType}[]) {}
}
